import { forwardRef, HTMLAttributes, memo } from "react";
import classNames from "classnames";

import styles from "./styles.module.scss"

export type DotSize = "sm" | "md" | "lg";

export type DotProps = HTMLAttributes<HTMLDivElement> & {
  size?: DotSize
  outline?: boolean
};

export const Dot = memo(forwardRef<HTMLDivElement, DotProps>((
  {
    size = "sm",
    outline = false,
    className,
    ...props
  }, ref) => {
  return (
    <div
      {...props}
      ref={ref}
      className={classNames(
        className,
        styles.root,
        styles[size], {
          [styles.outline]: outline
        }
      )}
    ></div>
  );
}));